import { QueryClient } from '@tanstack/react-query';

const STALE_MS = 60 * 1000;
const GC_MS = 5 * 60 * 1000;

export function createAppQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: STALE_MS,
        gcTime: GC_MS,
        retry: 1,
        refetchOnWindowFocus: false,
      },
    },
  });
}
